import { useEffect, useState } from "react";
import { Search, Download } from "lucide-react";
import api from "@/lib/api";

export default function SubscribersTable() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get(`/admin/newsletter${q ? `?q=${encodeURIComponent(q)}` : ""}`);
    setRows(data);
    setLoading(false);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [q]);

  const exportCsv = () => {
    const header = ["email", "name", "status", "source", "created_at"];
    const csv = [header.join(",")]
      .concat(rows.map((r) =>
        header.map((h) => `"${String(r[h] || "").replace(/"/g, '""')}"`).join(",")
      ))
      .join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const a = Object.assign(document.createElement("a"), {
      href: URL.createObjectURL(blob),
      download: `newsletter-${new Date().toISOString().slice(0, 10)}.csv`,
    });
    a.click();
  };

  return (
    <div data-testid="admin-newsletter">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-display text-2xl text-[var(--navy)]">
          Subscribers <span className="text-sm text-[var(--muted)] font-body ml-2">{rows.length}</span>
        </h2>
        <div className="flex items-center gap-2">
          <div className="relative">
            <Search size={13} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--muted)]" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search email or name"
                   className="pl-9 pr-3 py-2 border border-[var(--line)] text-sm w-64" data-testid="subscribers-search" />
          </div>
          <button onClick={exportCsv} className="text-xs px-3 py-2 border border-[var(--line)] flex items-center gap-2 hover:border-[var(--navy)]"
                  data-testid="subscribers-export">
            <Download size={13} /> CSV
          </button>
        </div>
      </div>

      {loading ? (
        <p className="text-sm text-[var(--muted)]">Loading…</p>
      ) : rows.length === 0 ? (
        <div className="text-center py-16 border border-dashed border-[var(--line)]">
          <p className="text-[var(--muted)] text-sm">No subscribers yet.</p>
        </div>
      ) : (
        <table className="w-full text-sm border border-[var(--line)]" data-testid="subscribers-table">
          <thead className="bg-[var(--cream)] text-[10px] uppercase tracking-widest text-[var(--muted)]">
            <tr>
              <th className="text-left px-4 py-3">Email</th>
              <th className="text-left px-4 py-3">Name</th>
              <th className="text-left px-4 py-3">Source</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-left px-4 py-3">Subscribed</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-[var(--line)]" data-testid={`sub-${r.email}`}>
                <td className="px-4 py-3 font-mono text-xs">{r.email}</td>
                <td className="px-4 py-3">{r.name || <span className="text-[var(--muted)]">—</span>}</td>
                <td className="px-4 py-3 text-xs text-[var(--muted)]">{(r.source || "").slice(0, 40)}</td>
                <td className="px-4 py-3">
                  <span className={`text-[10px] px-2 py-0.5 uppercase tracking-widest ${
                    r.status === "active" ? "bg-emerald-100 text-emerald-800" : "bg-neutral-200 text-neutral-700"
                  }`}>{r.status}</span>
                </td>
                <td className="px-4 py-3 text-xs text-[var(--muted)]">
                  {r.created_at ? new Date(r.created_at).toLocaleDateString() : ""}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
